import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '@/lib/branding';
import { Button } from '@/components/ui/button';
import { OPEN_COOKIE_SETTINGS_EVENT } from '@/hooks/useConsent';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border/50 mt-8 px-4 py-6 text-sm text-muted-foreground">
      <div className="flex flex-col sm:flex-row gap-4 items-center justify-between max-w-6xl mx-auto">
        <span>© {year} {APP_NAME}</span>
        <div className="flex items-center gap-4">
          <Link to="/legal/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
          <Link to="/legal/terms" className="hover:text-foreground transition-colors">Terms</Link>
          <Link to="/legal/cookies" className="hover:text-foreground transition-colors">Cookies</Link>
          <Button
            type="button"
            variant="link"
            className="h-auto p-0 font-normal text-muted-foreground hover:text-foreground"
            onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT))}
          >
            Cookie settings
          </Button>
          <a href="mailto:info@wealthtimeline.ai" className="hover:text-foreground transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  );
}
